import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { VoorbeeldenPage } from "@/pages/voorbeelden";

export const Route = createFileRoute("/$lang/exemples")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/voorbeelden",
      title: t("voorbeelden.title"),
      description: t("voorbeelden.description"),
    });
  },
  component: VoorbeeldenPage,
});
